import { Route, useLocation, useNavigate } from "react-router-dom";
import { AllTaskIndex, AllTasksMain, CreateAllTasks, EditAllTasks, ViewAllTask } from "../Views/Web/Task/MyTasks";
import MainTask from "../Views/Web/Task/TaskMain";
import { CreateMyTasks, EditMyTasks, MyTaskIndex, MyTasksMain, ViewMyTask } from "../Views/Web/Task/AllTasks";
import { useEffect } from "react";
import { Wrapper } from "../Components/Utils/roles";
import MainTasks from "../Views/Web/Tasks/MainTask";
import ViewTask from "../Views/Web/Tasks/Components/viewTask";
import CreateTask from "../Views/Web/Tasks/Components/createTask";
import SubTaskView from "../Views/Web/Tasks/Components/viewSubTask";
import EditTask from "../Views/Web/Tasks/Components/editTask";
import CreateSubTask from "../Views/Web/Tasks/Components/createSubTask";
import EditSubTask from "../Views/Web/Tasks/Components/editSubTask";
import MyTask from "../Views/Web/Tasks/MyTask";
import AllTask from "../Views/Web/Tasks/AllTask";
import MainAllTask from "../Views/Web/Tasks/AllTask/MainAllTask";
import MainMyTask from "../Views/Web/Tasks/MyTask/MainMyTask";



function TaskRoutes(){
    const location = useLocation();
    const navigate = useNavigate();
  
    useEffect(() => {
      if (
        location.pathname === "/tasks" ||
        location.pathname === "/tasks/") {
        navigate("/page-not-found")
      }
    },[location])
    return (
        // <Route path="tasks" element={<MainTask/>}>
        //     <Route path="all-tasks" element={<AllTasksMain/>} >
        //         <Route index element={<Wrapper accessKey={true}  Component={AllTaskIndex} />}/>
        //         <Route path="create" element={<Wrapper accessKey={true}  Component={CreateAllTasks} />}/>
        //         <Route path="edit/:allTaskEditId" element={<Wrapper accessKey={true}  Component={EditAllTasks} />}/>
        //         <Route path="view/:allTaskViewId" element={<Wrapper accessKey={true}  Component={ViewAllTask} />}/>
        //     </Route>
        //     <Route path="my-tasks" element={<MyTasksMain/>} >
        //     <Route index element={<Wrapper accessKey={true}  Component={MyTaskIndex} />}/>
        //         <Route path="create" element={<Wrapper accessKey={true}  Component={CreateMyTasks} />}/>
        //         <Route path="edit/:myTaskEditId" element={<Wrapper accessKey={true}  Component={EditMyTasks} />}/>
        //         <Route path="view/:myTaskViewId" element={<Wrapper accessKey={true}  Component={ViewMyTask} />}/>
        //     </Route>
        // </Route>
        <Route path="tasks" element={<MainTasks />}>
        <Route path="view/:taskViewId" element={<ViewTask />} />
        <Route path="subtask/view/:subTaskViewId" element={<SubTaskView />}/>
        <Route path="create" element={<CreateTask />} />
        <Route path="edit/:taskEditId" element={<EditTask />} />    
        <Route path="subtask/create" element={<CreateSubTask />} />
        <Route
          path="subtask/edit/:subTaskEditId"
          element={<EditSubTask />}
        />
        {/* <Route path="task-schedule" element={<MainTaskSchedule />}>
         <Route index element={<TaskSchedule/>} />
        </Route> */}
        <Route path='my-task' element={<MainMyTask/>}>
         <Route index element={<MyTask/>} />
        <Route path="edit/:taskEditId" element={<EditTask />} />  
        <Route path="view/:taskViewId" element={<ViewTask />} />


        </Route>
        <Route path='all-task' element={<MainAllTask/>}>
         <Route index element={<AllTask/>} />
        </Route>
        {/* <Route path='task-plan' element={<MainTasksPlan/>}>
         <Route index element={<TaskPlan/>} />
         <Route path="create" element={<CreateTask/>} />
         <Route path="view/:taskViewId" element={<ViewTask />} />
        </Route> */}
      </Route>
    )
}

export default TaskRoutes;